export function mockApiCall({ value, onInit, onResolve }) {
  onInit?.()

  return new Promise(resolve => {
    setTimeout(() => {
      onResolve?.()

      return resolve(value)
    }, 1000)
  })
}
